import './contactItemContainer.scss'


const ContactItemContainer = ({children}) => <div className='contact-item-container' children={children} />

export default ContactItemContainer
